<template>
  <iframe 
    :src="`../../../static/videoPlayer.html?source=${sourceUrl}`"
    style="border:0; height: 700px"
  ></iframe>
</template>

<script>
export default {
  data () {
    return {
      sourceUrl: null
    }
  },
  mounted () {
    this.createPlayer()
  },
  methods: {
    createPlayer () {
      const id = this.$route.query.id
      let {origin} = window.location
      if (process.env.NODE_ENV === 'development') {
        origin = window.globalConfig.webApi
      }

      this.sourceUrl = `${origin}/api/v2/files/download/${id}`
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/modules/history/videoPlayer.vue